import styled from 'styled-components';
import { Palette } from 'config';

export const LoaderWrap = styled.div`
  height: 180px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 16px;
  white-space: nowrap;
`;

export const Value = styled.p`
  font-size: 32px;
  line-height: 40px;
  font-weight: 700;
  color: ${Palette.PrimaryGray._700};
  margin-bottom: 8px;
`;

export const ChangeTitle = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${Palette.PrimaryGray._400};
  white-space: nowrap;
`;

export const ChangeValue = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ trend }) =>
    trend === 'up'
      ? Palette.Teal._600
      : trend === 'down'
      ? Palette.Red._600
      : Palette.PrimaryGray._400};
  margin-bottom: 16px;
  white-space: nowrap;

  &::after {
    content: '';
    display: ${({ trend }) => (trend ? 'inline-block' : 'none')};
    width: 8px;
    height: 4px;
    background-color: currentColor;
    clip-path: ${({ trend }) =>
      trend === 'up'
        ? 'polygon(50% 0, 100% 100%, 0 100%)'
        : trend === 'down'
        ? 'polygon(0 0, 100% 0, 50% 100%)'
        : 'none'};
  }
`;

export const GraphWrap = styled.div`
  display: flex;
  height: 100%;
  min-height: 40px;
  color: ${({ trend }) => (trend === 'up' || !trend ? Palette.Primary._300 : Palette.Red._300)};
`;

export const GraphFill = styled.path`
  fill: ${({ trend }) => (trend === 'up' || !trend ? Palette.Primary._000 : Palette.Red._000)};
`;
